<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入分类名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.type"
            placeholder="请选择分类类型"
            style="width: 180px; margin-right: 10px"
            clearable
          >
            <el-option
              v-for="item in lxtype"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getCateList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加分类</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="分类名称" prop="name" min-width="200" />

          <el-table-column label="类型" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getTypeColor(scope.row.type)">
                {{ getTypeName(scope.row.type) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            label="排序"
            prop="sort"
            width="100"
            align="center"
          />
          <el-table-column label="状态" width="180" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-text="开启"
                inactive-text="关闭"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(scope.row)"
              />
            </template>
          </el-table-column>

          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加分类' : '编辑分类'"
          :visible.sync="pcDialogVisible"
          width="550px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="100px"
          >
            <el-form-item label="分类名称" prop="name">
              <el-input
                v-model="pcForm.name"
                placeholder="请输入分类名称"
                style="width: 300px"
              />
            </el-form-item>

            <el-form-item label="分类类型" prop="type">
              <el-select
                v-model.number="pcForm.type"
                placeholder="请选择类型"
                style="width: 300px"
              >
                <el-option
                  v-for="item in lxtype"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model.number="pcForm.sort"
                :min="1"
                style="width: 300px"
              ></el-input-number>
            </el-form-item>

            <!-- 图片表单项整体移除 -->
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- PC 图片选择弹窗（保留代码但不会再调用） -->
        <el-dialog
          title="选择图片"
          :visible.sync="pcImageDialogVisible"
          width="850px"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="图片加载中..."
            style="padding: 10px"
          >
            <div
              style="
                display: flex;
                gap: 10px;
                margin-bottom: 15px;
                align-items: center;
              "
            >
              <el-select
                v-model.number="pcImageSearch.type"
                placeholder="图片类型"
                style="width: 180px"
                clearable
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="getImageList"
                >筛选</el-button
              >
              <el-button icon="el-icon-refresh" @click="resetImageSearch"
                >重置</el-button
              >
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 12px;
                max-height: 420px;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="pcSelectImage(img)"
                style="
                  cursor: pointer;
                  padding: 4px;
                  border-radius: 6px;
                  text-align: center;
                "
                :style="{
                  border:
                    pcSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    pcSelectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    margin-top: 4px;
                    color: #666;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <el-pagination
              @size-change="handleImageSizeChange"
              @current-change="handleImageCurrentChange"
              :current-page="pcImageSearch.page"
              :page-size="pcImageSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="imageTotal"
              style="margin-top: 15px; text-align: right"
            ></el-pagination>
          </div>

          <div slot="footer">
            <el-button @click="pcImageDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcConfirmSelectImage"
              >确认选择</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 搜索栏 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="分类名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.type"
              placeholder="分类类型"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in lxtype"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getCateList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <!-- 卡片列表 移除图片头像 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">ID:{{ item.id }} | 排序:{{ item.sort }}</div>
              </div>
              <el-tag :type="getTypeColor(item.type)" size="mini">
                {{ getTypeName(item.type) }}
              </el-tag>
            </div>
            <div class="card-body">
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-switch
                v-model="item.status"
                size="mini"
                active-text="开启"
                inactive-text="关闭"
                :active-value="1"
                :inactive-value="0"
                @click.native.stop
                @change="handleStatus(item)"
              />
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端添加/编辑弹窗 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加分类' : '编辑分类'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="85px"
            size="small"
          >
            <el-form-item label="分类名称" prop="name">
              <el-input v-model="mobileForm.name" placeholder="名称" size="medium" />
            </el-form-item>
            <el-form-item label="分类类型" prop="type">
              <el-select
                v-model.number="mobileForm.type"
                placeholder="类型"
                size="medium"
              >
                <el-option
                  v-for="item in lxtype"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model.number="mobileForm.sort"
                :min="1"
                size="medium"
                style="width: 100%"
              />
            </el-form-item>
            <!-- 移动端图片选择表单项移除 -->
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="mobileSubmitForm"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端图片弹窗保留，不再调用 -->
        <el-dialog
          title="选择图片"
          :visible.sync="mobileImageDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div
            v-loading="imageLoading"
            element-loading-text="加载中..."
            style="padding: 5px"
          >
            <div style="display: flex; gap: 8px; margin-bottom: 10px">
              <el-select
                v-model.number="mobileImageSearch.type"
                placeholder="类型"
                size="mini"
                clearable
                style="flex: 1"
              >
                <el-option
                  v-for="item in image_type"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
              <el-button size="mini" type="primary" @click="getImageList"
                >筛选</el-button
              >
              <el-button size="mini" @click="resetImageSearch">重置</el-button>
            </div>

            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                max-height: 45vh;
                overflow-y: auto;
                padding: 5px;
              "
            >
              <div
                v-for="img in imageList"
                :key="img.id"
                @click="mobileSelectImage(img)"
                style="
                  padding: 3px;
                  border-radius: 6px;
                  cursor: pointer;
                  text-align: center;
                "
                :style="{
                  border:
                    mobileSelectedImageUrl == img.url
                      ? '2px solid #1989fa'
                      : '2px solid transparent',
                  background:
                    mobileSelectedImageUrl == img.url ? '#f0f7ff' : 'transparent',
                }"
              >
                <img
                  :src="img.url"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                    display: block;
                  "
                />
                <span
                  style="
                    font-size: 12px;
                    color: #666;
                    margin-top: 3px;
                    display: block;
                  "
                >
                  {{ getImageTypeName(img.type) }}
                </span>
              </div>
            </div>

            <div style="margin-top: 10px; text-align: center">
              <el-pagination
                @size-change="handleImageSizeChange"
                @current-change="handleImageCurrentChange"
                :current-page="mobileImageSearch.page"
                :page-size="mobileImageSearch.page_size"
                layout="prev, pager, next"
                :total="imageTotal"
              />
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button size="mini" @click="mobileImageDialogVisible = false"
              >取消</el-button
            >
            <el-button size="mini" type="primary" @click="mobileConfirmSelectImage"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "BlindCateTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
        name: "",
        type: "",
      },
      addRules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择分类类型", trigger: "change" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        // url 校验移除
      },
      lxtype: [],

      // ==================== PC 独立数据 ====================
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        cate_id: "",
        name: "",
        type: "",
        sort: "",
        url: "",
      },
      pcImageDialogVisible: false,
      pcImageSearch: { page: 1, page_size: 12, type: "" },
      pcSelectedImageUrl: "",

      // ==================== 移动端独立数据 ====================
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        cate_id: "",
        name: "",
        type: "",
        sort: "",
        url: "",
      },
      mobileImageDialogVisible: false,
      mobileImageSearch: { page: 1, page_size: 12, type: "" },
      mobileSelectedImageUrl: "",

      // 图片公共数据
      imageLoading: false,
      imageList: [],
      imageTotal: 0,
      image_type: [],
    };
  },
  created() {
    this.getCateList();
  },
  methods: {
    // 公共列表
    getCateList() {
      this.loading = true;
      api.blindCate
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.lxtype = res.data.data.type;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTypeName(type) {
      const item = this.lxtype.find((t) => t.type == type);
      return item ? item.desc : "未知";
    },
    getTypeColor(type) {
      const colors = {
        1: "success",
        2: "primary",
        3: "warning",
        4: "danger",
        5: "info",
        6: "success",
        7: "primary",
        99: "",
      };
      return colors[type] || "info";
    },

    // ==================== PC 方法 ====================
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        cate_id: row.id,
        name: row.name,
        type: Number(row.type),
        sort: row.sort,
        url: row.url,
      };
      this.pcDialogVisible = true;
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const apiFn = this.pcDialogType === "add" ? api.blindCate.add : api.blindCate.edit;
        apiFn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getCateList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    pcResetForm() {
      this.pcForm = {
        cate_id: "",
        name: "",
        type: "",
        sort: "",
        url: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcOpenImageDialog() {
      this.pcImageDialogVisible = true;
      this.pcSelectedImageUrl = "";
      this.getImageList();
    },
    pcSelectImage(img) {
      this.pcSelectedImageUrl = img.url;
    },
    pcConfirmSelectImage() {
      if (!this.pcSelectedImageUrl) {
        this.$message.warning("请先选择一张图片");
        return;
      }
      this.pcForm.url = this.pcSelectedImageUrl;
      this.pcImageDialogVisible = false;
    },

    // ==================== 移动端方法 ====================
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        cate_id: row.id,
        name: row.name,
        type: Number(row.type),
        sort: row.sort,
        url: row.url,
      };
      this.mobileDialogVisible = true;
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const apiFn = this.mobileDialogType === "add" ? api.blindCate.add : api.blindCate.edit;
        apiFn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getCateList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    mobileResetForm() {
      this.mobileForm = {
        cate_id: "",
        name: "",
        type: "",
        sort: "",
        url: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileOpenImageDialog() {
      this.mobileImageDialogVisible = true;
      this.mobileSelectedImageUrl = "";
      this.getImageList();
    },
    mobileSelectImage(img) {
      this.mobileSelectedImageUrl = img.url;
    },
    mobileConfirmSelectImage() {
      if (!this.mobileSelectedImageUrl) {
        this.$message.warning("请先选择一张图片");
        return;
      }
      this.mobileForm.url = this.mobileSelectedImageUrl;
      this.mobileImageDialogVisible = false;
    },

    // ==================== 公共方法 ====================
    handleStatus(row) {
      const oldStatus = row.status;
      this.loading = true;
      api.blindCate
        .status({
          cate_id: String(row.id),
          status: String(row.status),
        })
        .then((res) => {
          if (res.data.code != 1000) row.status = oldStatus;
        })
        .catch(() => {
          row.status = oldStatus;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        name: "",
        type: "",
      };
      this.getCateList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getCateList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getCateList();
    },
    getImageList() {
      this.imageLoading = true;
      api.images
        .index({ params: this.pcImageSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.imageList = res.data.data.data || [];
            this.imageTotal = res.data.data.total || 0;
            this.image_type = res.data.data.image_type || [];
          }
        })
        .finally(() => {
          this.imageLoading = false;
        });
    },
    resetImageSearch() {
      this.pcImageSearch = { page: 1, page_size: 12, type: "" };
      this.mobileImageSearch = { page: 1, page_size: 12, type: "" };
      this.getImageList();
    },
    handleImageSizeChange(val) {
      this.pcImageSearch.page_size = val;
      this.mobileImageSearch.page_size = val;
      this.getImageList();
    },
    handleImageCurrentChange(val) {
      this.pcImageSearch.page = val;
      this.mobileImageSearch.page = val;
      this.getImageList();
    },
    getImageTypeName(type) {
      const item = this.image_type.find((t) => t.type == type);
      return item ? item.desc : "未知分类";
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* ====================== 移动端样式 ====================== */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/goods/cate.vue